import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { usePolling } from "@/hooks/usePolling";

export default function Twins() {
  const { data, error } = usePolling(() => api.get("/twins").then((r) => r.data), 10000);

  if (error) return <div className="text-sm text-[var(--oim-text-muted)]" data-testid="twins-error">Could not load twins.</div>;
  if (!data) return <div className="text-sm text-[var(--oim-text-muted)]" data-testid="twins-loading">Loading…</div>;

  return (
    <div className="space-y-4" data-testid="twins-page">
      <h1 className="text-2xl font-bold font-heading text-[var(--oim-text)]">Digital Twins</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {data.map((t) => (
          <Link
            key={t.twin_id}
            to={`/twins/${t.twin_id}`}
            className="rounded-xl border p-4 block hover:bg-[var(--oim-hover)] transition-colors"
            style={{ borderColor: "var(--oim-border)", backgroundColor: "var(--oim-surface)" }}
            data-testid={`twin-card-${t.twin_id}`}
          >
            <div className="text-sm font-heading font-bold text-[var(--oim-text)]">{t.label}</div>
            <div className="text-[10px] uppercase tracking-wide text-[var(--oim-text-dim)] mt-1">{t.chain} · {t.process}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
